import React, { Component } from "react";
import "./_WpuForm.scss"

class WpuDetail extends Component {

	constructor(props){
		super(props)
		this.state = {
			error: false,
			message: "",
		}
	}

	errorMessagesHandler = (accountInfoCreds,accountNumber,zip) => {
		if((typeof accountInfoCreds !== "object") || (accountNumber.length < 14 && zip.length < 5)){
			this.setState({
				error: true,
				message: "Something seems amiss with both of these entries. Please take a look at each field, and try again, thanks!"
			})
		} else if(accountNumber.length < 14 && zip.length === 5){
			this.setState({
				error: true,
				message: "Sorry, this Billing Account Number is invalid. Please input a 13-digit number."
			})
		} else if(accountNumber.length === 14 && zip.length < 5){
			this.setState({
				error: true,
				message: "Sorry, this U.S. Billing Zip Code doesn’t seem to be working."
			})
		}
	}

	submitHandler = (accountInfoCreds) => {
		let { accountNumber, zip } = accountInfoCreds
		//Form validation
		// this.props.history.push("/accounts");
		if (accountInfoCreds.accountNumber && accountInfoCreds.zip && accountInfoCreds.accountNumber.length === 10 && accountInfoCreds.zip.length === 8) {
			this.props.loadAccounts(accountInfoCreds.accountNumber, accountInfoCreds.zip, this.props.history)

		} else {
			this.errorMessagesHandler(accountInfoCreds,accountNumber,zip);
			
		}
	};


	render (){

		return(
		<div className="pcg-page">
			<div className="SiteHeader">
				<div className="logo-area">
					<div className="logo" onClick={this.handleRouteToHome} tabIndex="0">
							<img src="/media/icons/aig-brand-blue.svg" alt="AIG Brand - Navigate to Welcome Screen"/>
					</div>
					<div className="logo-title">
						Private Client Group
					</div>
				</div>
			</div>
			<div className="pcg-main">

				{/* <div className="_WpuDetailCenter">

						<WpuDetailSubmitForm
							error={error}
							errorMessage={message}
							submitHandler={this.submitHandler}
							billingAccountLength={14}
							zipCodeLength={5}
						/>
					</div> */}
				</div>
			</div>
	);
	}
}
export default WpuDetail;



// WEBPACK FOOTER //
// ./src/components/atomic/pages/WpuDetail/WpuDetail.js